var exports = {
  "Gh": "BlockedUsersTab.module__userList___d3JCUk",
  "Kg": "BlockedUsersTab.module__userCard___d3JCUk",
  "eF": "BlockedUsersTab.module__userInfo___d3JCUk",
  "KI": "BlockedUsersTab.module__avatarButton___d3JCUk",
  "xO": "BlockedUsersTab.module__usernameButton___d3JCUk",
  "QV": "BlockedUsersTab.module__usernameContainer___d3JCUk",
  "Xh": "BlockedUsersTab.module__username___d3JCUk",
  "D2": "BlockedUsersTab.module__discriminator___d3JCUk",
  "o1": "BlockedUsersTab.module__actions___d3JCUk",
  "lK": "BlockedUsersTab.module__moreIcon___d3JCUk",
};

module.exports = exports;
